var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "ul",
        { staticClass: "panel-form-field-buttons" },
        _vm._l(_vm.fields, function(field, index) {
          return _c(
            "li",
            {
              key: index,
              staticClass: "panel-button",
              class: {
                "button-faded":
                  _vm.is_pro_feature(field) || _vm.is_failed_to_validate(field)
              },
              attrs: { "data-form-field": field, "data-source": "panel" },
              on: {
                click: function($event) {
                  return _vm.handleClick(field)
                }
              }
            },
            [
              _vm.field_settings[field].icon
                ? _c("i", {
                    class: ["fa", "fa-" + _vm.field_settings[field].icon],
                    attrs: { "aria-hidden": "true" }
                  })
                : _vm._e(),
              _vm._v(
                "\n    " + _vm._s(_vm.field_settings[field].title) + "\n  "
              )
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("ProFeature", {
        attrs: { visibility: _vm.whyDisabledModal, modal: _vm.model },
        on: {
          "update:visibility": function($event) {
            _vm.whyDisabledModal = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }